import React from 'react';
import LegalPage, { Section } from './LegalPage';

export default function CookiePage() {
  return (
    <LegalPage
      title="Cookie Policy"
      subtitle="Informativa sull'uso dei cookie ai sensi del Provv. Garante n. 231/2021 e dell'art. 13 GDPR."
      lastUpdate="21 giugno 2026"
    >
      <Section title="Cosa sono i cookie">
        <p>
          I cookie sono piccoli file di testo che i siti visitati salvano sul terminale dell'utente,
          dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.
        </p>
      </Section>

      <Section title="Cookie utilizzati da questo sito">
        <p>
          Questo sito <strong>non utilizza cookie di profilazione</strong> né strumenti di analytics di terze parti
          (es. Google Analytics, Facebook Pixel) né cookie pubblicitari.
        </p>
        <p>Vengono utilizzati esclusivamente i seguenti elementi tecnici, per i quali <strong>non è richiesto consenso preventivo</strong>:</p>
        <div className="overflow-x-auto pt-2">
          <table className="w-full text-xs border border-forest/15">
            <thead className="bg-sageLight/40">
              <tr className="text-left">
                <th className="p-3 font-semibold">Nome</th>
                <th className="p-3 font-semibold">Tipo</th>
                <th className="p-3 font-semibold">Scopo</th>
                <th className="p-3 font-semibold">Durata</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t border-forest/10">
                <td className="p-3 font-mono">psicologo_jwt</td>
                <td className="p-3">Local Storage</td>
                <td className="p-3">Mantiene la sessione del Dr. Balducci nell'area riservata</td>
                <td className="p-3">8 ore</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Section>

      <Section title="Strumenti di terze parti">
        <p>
          Il sito carica i font web Fraunces e Plus Jakarta Sans tramite Google Fonts. Il caricamento del font
          comporta una richiesta HTTP al server di Google ma <strong>non installa cookie</strong>. L'indirizzo IP del visitatore
          può essere registrato da Google a fini esclusivamente tecnici.
        </p>
      </Section>

      <Section title="Come disabilitare i cookie">
        <p>
          Puoi gestire le preferenze relative ai cookie direttamente dal tuo browser. I principali browser
          consentono di bloccare e cancellare i cookie già memorizzati:
        </p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><a className="text-forest underline" href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">Google Chrome</a></li>
          <li><a className="text-forest underline" href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noreferrer">Mozilla Firefox</a></li>
          <li><a className="text-forest underline" href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer">Safari</a></li>
          <li><a className="text-forest underline" href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noreferrer">Microsoft Edge</a></li>
        </ul>
      </Section>

      <Section title="Aggiornamenti">
        <p>
          Qualora venissero introdotti cookie di profilazione o di terze parti, questa pagina sarà aggiornata
          e l'utente verrà invitato ad esprimere il consenso tramite apposito banner.
        </p>
      </Section>
    </LegalPage>
  );
}
